/**
 * Structured error codes for lounge mutations.
 *
 * Throw via `new ConvexError({ code: <CODE> })` so clients can detect the
 * error type via `isConvexErrorWithCode(err, <CODE>)` and render
 * user-friendly copy instead of leaking the raw Convex wrapper.
 *
 * Note: capacity-related errors (e.g. `LOUNGE_FULL_ERROR_CODE`) live in
 * `./capacity.ts` next to the limit constants they relate to.
 */

export const INVALID_JOIN_CODE_ERROR_CODE = 'INVALID_JOIN_CODE'

/** Thrown when joining a lounge whose status is not `active` (e.g. suspended or archived). */
export const LOUNGE_INACTIVE_ERROR_CODE = 'LOUNGE_INACTIVE'

/**
 * Thrown when a user who previously left or was removed from a lounge tries to rejoin
 * via share code. Only the lounge owner can bring them back.
 */
export const LOUNGE_REJOIN_REQUIRES_OWNER_ERROR_CODE = 'LOUNGE_REJOIN_REQUIRES_OWNER'

/**
 * Thrown when a non-member tries to join a lounge game via an invite link but the
 * lounge does not allow open invites (`settings.membersCanInvite` is off), or when
 * auto-join is otherwise not permitted (e.g. the user was previously removed).
 * Clients render a friendly "you need to be invited" message for this code.
 */
export const LOUNGE_INVITE_ONLY_ERROR_CODE = 'LOUNGE_INVITE_ONLY'

/** Thrown by `setLoungeJoinCode` when another lounge already uses the requested code. */
export const JOIN_CODE_TAKEN_ERROR_CODE = 'JOIN_CODE_TAKEN'

/** Thrown by `setLoungeJoinCode` when the requested code fails `getLoungeJoinCodeFormatError`. */
export const JOIN_CODE_FORMAT_ERROR_CODE = 'JOIN_CODE_FORMAT'
